import { GeoFenceOutputWithOutStatus } from './geo-fence-output-with-out-status.model';


export class GeofenceSelectByIdOutput implements IGeofenceSelectByIdOutput {
    status!: number;
    message!: string;
    data!: GeoFenceOutputWithOutStatus;

    constructor(data?: IGeofenceSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? GeoFenceOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeofenceSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGeofenceSelectByIdOutput {
    status: number;
    message: string;
    data: GeoFenceOutputWithOutStatus;
}

